import { useTranslation } from 'react-i18next';
import { WifiOff, RefreshCw } from 'lucide-react';
import { Page } from '@/components/layout/Page';
import { PageContent } from '@/components/layout/PageContent';

export function NetworkErrorPage() {
    const { t } = useTranslation();

    return (
        <Page className="bg-slate-50">
            <PageContent width="narrow" className="flex flex-col items-center justify-center min-h-[80vh] text-center">
                <div className="w-24 h-24 bg-red-50 rounded-3xl flex items-center justify-center mb-6">
                    <WifiOff size={48} className="text-red-300" />
                </div>

                <h2 className="text-xl font-bold text-slate-900 mb-2">{t('errorPage.network.title')}</h2>
                <p className="text-slate-500 mb-8 max-w-sm">{t('errorPage.network.message')}</p>

                <button
                    onClick={() => window.location.reload()}
                    className="bg-slate-900 text-white px-6 py-3 rounded-2xl font-bold flex items-center gap-2 hover:bg-slate-800 transition-all"
                >
                    <RefreshCw size={18} />
                    {t('errorPage.retry')}
                </button>
            </PageContent>
        </Page>
    );
}
